import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";

import { auth, db } from "../firebase/config";

// Add Workout Plan
export const addWorkoutPlan = async (plan) => {
  const gymId = auth.currentUser.uid;

  await addDoc(collection(db, "gyms", gymId, "workoutPlans"), {
    ...plan,
    createdAt: new Date().toISOString(),
  });
};

// Get All Workout Plans
export const getWorkoutPlans = async () => {
  const gymId = auth.currentUser.uid;

  const snapshot = await getDocs(collection(db, "gyms", gymId, "workoutPlans"));

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get Single Workout Plan
export const getWorkoutPlan = async (id, gymId = auth.currentUser?.uid) => {
  const snapshot = await getDoc(doc(db, "gyms", gymId, "workoutPlans", id));

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
};

// Update Workout Plan
export const updateWorkoutPlan = async (id, data) => {
  const gymId = auth.currentUser.uid;

  await updateDoc(doc(db, "gyms", gymId, "workoutPlans", id), data);
};

// Delete Workout Plan
export const deleteWorkoutPlan = async (id) => {
  const gymId = auth.currentUser.uid;

  await deleteDoc(doc(db, "gyms", gymId, "workoutPlans", id));
};
